import { Step } from 'react-joyride';
import { translate } from '../../../i18n';

export const PRICING_TOUR_ID = 'pricing-management';

export function pricingTourSteps(): Step[] {
  return [
    {
      target: '[data-tour="court-pricing"]',
      title: translate('walkthrough.pricing_court_title'),
      content: translate('walkthrough.pricing_court_content'),
      disableBeacon: true,
    },
    {
      target: '[data-tour="coach-pricing"]',
      title: translate('walkthrough.pricing_coach_title'),
      content: translate('walkthrough.pricing_coach_content'),
    },
    {
      target: '[data-tour="game-duration"]',
      title: translate('walkthrough.pricing_duration_title'),
      content: translate('walkthrough.pricing_duration_content'),
    },
    {
      target: '[data-tour="refund-policy"]',
      title: translate('walkthrough.pricing_refund_title'),
      content: translate('walkthrough.pricing_refund_content'),
    },
    {
      target: '[data-tour="discount-policy"]',
      title: translate('walkthrough.pricing_discount_title'),
      content: translate('walkthrough.pricing_discount_content'),
    },
  ];
}
